import { Component, computed, inject, input, output } from '@angular/core';
import type { ModalAction } from '@purolator/ui-kit-angular';
import { ModalComponent, TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe, TranslationService } from '../../../../../core/i18n';
import { SERVICE_GUARANTEES_TERMS_URLS } from '../service-guarantees.constants';

const BULLET_KEYS = [
  'createShipment.serviceStep.deliveryService.guaranteesModal.bullet1',
  'createShipment.serviceStep.deliveryService.guaranteesModal.bullet2',
  'createShipment.serviceStep.deliveryService.guaranteesModal.bullet3',
  'createShipment.serviceStep.deliveryService.guaranteesModal.bullet4',
  'createShipment.serviceStep.deliveryService.guaranteesModal.bullet5',
  'createShipment.serviceStep.deliveryService.guaranteesModal.bullet6',
] as const;

/**
 * Informational modal for Service Guarantees copy and Terms & Conditions link (OM-340 CR).
 */
@Component({
  selector: 'app-service-guarantees-dialog',
  imports: [ModalComponent, TypographyComponent, TranslatePipe],
  templateUrl: './service-guarantees-dialog.html',
  styleUrl: './service-guarantees-dialog.scss',
})
export class ServiceGuaranteesDialog {
  private readonly translation = inject(TranslationService);

  readonly open = input(false);
  readonly closed = output<void>();

  protected readonly bulletKeys = BULLET_KEYS;

  protected readonly modalTitle = computed(() => {
    this.translation.revision();
    return this.translation.translate(
      'createShipment.serviceStep.deliveryService.guaranteesModal.title',
    );
  });

  protected readonly termsHref = computed(() => {
    this.translation.revision();
    return this.translation.locale() === 'fr'
      ? SERVICE_GUARANTEES_TERMS_URLS.fr
      : SERVICE_GUARANTEES_TERMS_URLS.en;
  });

  protected readonly closeActions = computed<ModalAction[]>(() => {
    this.translation.revision();
    return [
      {
        label: this.translation.translate(
          'createShipment.serviceStep.deliveryService.guaranteesModal.close',
        ),
        variant: 'primary',
        onClick: () => this.onClose(),
      },
    ];
  });

  /**
   * Emits when the dialog should close (X, backdrop, or Close action).
   */
  protected onClose(): void {
    this.closed.emit();
  }
}
